import createAction from "redux-actions/es/createAction";
import { fetchJenkinsJobsEngr as api } from "../api/index";
import { statusJenkinsJobEngr as statusJenkinsJobEngrApi } from "../api/index";
import { buildJenkinsJob as buildJenkinsJobApi } from "../api/index";
import { getBuildTableData as getBuildTableDataApi } from "../api/index";
import { uiEralyFeedBackbuildJenkinsJob as uiEralyFeedBackbuildJenkinsJobApi } from "../api/index";
import { uiEarlyFeedbackStatusJenkinsJob as uiEarlyFeedbackStatusJenkinsJobApi } from "../api/index";
import { getFeatureNames as getFeatureNamesApi, getAllTestSteps as getAllTestStepsApi } from "../api/index";
import { getFeatureSteps as getFeatureStepsApi } from "../api/index";
import {salesForceCustomerInfomationSuccess, salesForceCustomerInfomationFail} from "../../salesforce-login/actions/index";

import { getPageState as getPageStateApi } from "../../customer/api/index";
export const jenkinJobStatus = createAction("JENKIN_JOB_ENGR_START");
export const jenkinJobEngrSuccess = createAction("JENKIN_JOB_ENGR_SUCCESS");
export const jenkinJobEngrUpdate = createAction("JENKIN_JOB_ENGR_UPDATE");
export const jenkinJobEngrForceUpdate = createAction("JENKIN_JOB_ENGR_FORCE_UPDATE");
export const jenkinPieChartUpdate = createAction("JENKIN_PIE_CHART_UPDATE");
export const jenkinJobEngrAddRow = createAction("JENKIN_JOB_ENGR_ADD_ROW");
export const jenkinJobEngrFail = createAction("JENKIN_JOB_ENGR_FAIL");
export const jenkinJobEngrClear = createAction("JENKIN_JOB_ENGR_CLEAR");

export const buildJenkinsJob = createAction("BUILD_JENKIN_JOB_START");
export const buildJenkinsJobSuccess = createAction("BUILD_JENKIN_JOB_SUCCESS");
export const buildJenkinsJobUpdate = createAction("BUILD_JENKIN_JOB_UPDATE");
export const buildJenkinsJobFail = createAction("BUILD_JENKIN_JOB_FAIL");
export const buildJenkinsJobClear = createAction("BUILD_JENKIN_JOB_CLEAR");

export const redirectUrlStart = createAction("REDIRECT_URL_START");
export const redirectUrlSuccess = createAction("REDIRECT_URL_SUCCESS");
export const redirectUrlFail = createAction("REDIRECT_URL_FAIL");
export const redirectUrlClear = createAction("REDIRECT_URL_CLEAR");

export const getFeatureNameStart = createAction("GET_FEATURED_NAME_START");
export const getFeatureNameSuccess = createAction("GET_FEATURED_NAME_SUCCESS");
export const getFeatureNameFail = createAction("GET_FEATURED_NAME_FAIL");
export const getFeatureNameClear = createAction("GET_FEATURED_NAME_CLEAR");

export const getFeatureStepsStart = createAction("GET_FEATURED_STEPS_START");
export const getFeatureStepsSuccess = createAction("GET_FEATURED_STEPS_SUCCESS");
export const getFeatureStepsFail = createAction("GET_FEATURED_STEPS_FAIL");
export const getFeatureStepsClear = createAction("GET_FEATURED_STEPS_CLEAR");

export const allTestCasesStart = createAction("ALL_TEST_CASES_START");
export const allTestCasesSuccess = createAction("ALL_TEST_CASES_SUCCESS");
export const allTestCasesFail = createAction("ALL_TEST_CASES_FAIL");
export const allTestCasesClear = createAction("ALL_TEST_CASES_CLEAR");




// export const fetchJenkinsJobsEngr = (data) => {
//   return async (dispatch) => {
//     await api(data)
//       .then((res) => {
//         if (res?.data?.status === "success") {
//           let data = res?.data?.builds;
//           dispatch(jenkinJobEngrSuccess(data));
//         }
//       })
//       .catch((err) => {
//         dispatch(jenkinJobEngrFail(err));
//       });
//   };
// };
// New Api for Build 
export const fetchJenkinsJobsEngr = (data) => {
  return async (dispatch) => {
    await getBuildTableDataApi(data)
      .then((res) => {
        if (res?.data?.status === "success") {
          let data = res?.data?.latestBuild;
          dispatch(jenkinJobEngrSuccess([data]));
        }
      })
      .catch((err) => {
        dispatch(jenkinJobEngrFail(err));
      });
  };
};

export const fetchJenkinsJobsEngrForceUpdTE = (data) => {
  return async (dispatch) => {
    await  dispatch(jenkinJobEngrForceUpdate([data]));
  };
};
export const fetchJenkinsJobsEngrClear = (data) => {
  return async (dispatch) => {
    dispatch(jenkinJobEngrSuccess([]));
  };
};

// export const fetchJenkinsJobsEngrUpdate = (data) => {
//   return async (dispatch) => {
//     await statusJenkinsJobEngrApi(data)
//       .then((res) => {
//           let resData = { jobId: data?.jobId, jobStatus: res?.data?.jobStatus };
//           dispatch(jenkinJobEngrUpdate(res.data));
//       })
//       .catch((err) => {
//         dispatch(jenkinJobEngrFail(err));
//       });
//   };
// };
export const uiEarlyFeedbackStatusJenkinsJob = (data) => {
  return async (dispatch) => {
    await uiEarlyFeedbackStatusJenkinsJobApi(data)
      .then((res) => {
          // let resData = { jobId: data?.jobId, jobStatus: res?.data?.jobStatus };
          let resData={
            orgId:data.orgId,
            jobName:data.jobName,
            buildNumber:data.buildNumber,
            jobId:data.jobId
          }
          dispatch(jenkinJobEngrUpdate({...res.data, ...{'active':(res.data.jobStatus==="Completed"?false:true)} }));
         
          // if(res?.data?.jobStatus==="InProgress"){
          //   setTimeout(()=>{
          //     dispatch(uiEarlyFeedbackStatusJenkinsJob(resData));
          //     dispatch(jenkinJobEngrUpdate(res.data));
          //   },10000);
          // }
          // if(res?.data?.jobStatus==="Completed"){
          //   let val={
          //     orgId:data.orgId
          //   }
          //   dispatch(fetchJenkinsJobsEngr(val));
          // }
      })
      .catch((err) => {
        dispatch(jenkinJobEngrFail(err));
      });
  };
};
export const getBuildJenkinsJob = (data) => {
  return async (dispatch) => {
    await buildJenkinsJobApi(data)
      .then((res) => {
          dispatch(jenkinJobEngrAddRow({...res.data, ...{active:true}}));
      })
      .catch((err) => {
        dispatch(buildJenkinsJobFail(err));
      });
  };
};
export const uiEralyFeedBackbuildJenkinsJob = (data) => {
  return async (dispatch) => {
    await uiEralyFeedBackbuildJenkinsJobApi(data)
      .then((res) => {
          dispatch(jenkinJobEngrAddRow({...res.data, ...{active:true}}));
      })
      .catch((err) => {
        dispatch(buildJenkinsJobFail(err));
      });
  };
};

export const redirectUrl = (data) => {
  return (dispatch) => {
    dispatch(redirectUrlSuccess(data));
  };
};

export const getAllTestCasesWithDetails = (data) => {
  return async (dispatch) => {
    await getAllTestStepsApi(data)
      .then((res) => {
          dispatch(allTestCasesSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(allTestCasesFail(err));
      });
  };
};

export const getFeatureNames = (data) => {
  return async (dispatch) => {
    await getFeatureNamesApi(data)
      .then((res) => {
          dispatch(getFeatureNameSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(getFeatureNameFail(err));
      });
  };
};
export const getFeatureSteps = (idata, id) => {
  return async (dispatch) => {
    await getFeatureStepsApi(idata)
      .then((res) => {
          dispatch(getFeatureStepsSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(getFeatureStepsFail(err));
      });
  };
};


export const getPageState = (data, token) => {
  return async (dispatch) => {
    await getPageStateApi(data, token)
      .then((res) => {
        dispatch(salesForceCustomerInfomationSuccess(res.data));
        // let dataUser=res.data;
        // dataUser['stageOn']="failure-triaging";
      })
      .catch((err) => {
        dispatch(salesForceCustomerInfomationFail(err));
      });
  };
};